import { render } from "./ProductLink.vue?vue&type=template&id=692bb2a0&lang=pug"
import script from "./ProductLink.vue?vue&type=script&lang=js"
export * from "./ProductLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__